import { GraphUtils } from '@helpers/graph.helper';
import { Sensor, dataChart } from './sensor';
import { Router } from '@angular/router';

export class HumidificationSensor extends Sensor {
  public humidityChart: any;
  public temperatureChart: any;

  private humiditySensor: any[];
  private temperatureSensor: any[];

  constructor(router: Router, url: string, alerstActive: boolean) {
    super(router, url, alerstActive);
    this.humidityChart = null;
    this.temperatureChart = null;

    this.humiditySensor = [[], [], []];
    this.temperatureSensor = [[], [], []];
  }

  public hasHumiditySensor(pos: number): boolean {
    return this.humiditySensor[pos - 1].length > 0;
  }

  public getHumiditySensor(pos: number): any {
    const realPos: number = this.humiditySensor[pos - 1].length - 1;
    return this.humiditySensor[pos - 1][realPos][1] ?? null;
  }

  public hasTemperatureSensor(pos: number): boolean {
    return this.temperatureSensor[pos - 1].length > 0;
  }

  public getTemperatureSensor(pos: number): any {
    const realPos: number = this.temperatureSensor[pos - 1].length - 1;
    return this.temperatureSensor[pos - 1][realPos][1] ?? null;
  }

  public prepareData(): void {
    for (const element of this.data) {
      const date = new Date(element.date);
      this.humiditySensor[element.position].push([
        GraphUtils.getDateUtc(date),
        element.humidity,
      ]);
      this.temperatureSensor[element.position].push([
        GraphUtils.getDateUtc(date),
        element.temperature,
      ]);
    }
  }

  public setCharts(): void {
    this.humidityChart = this.getConfigChar(
      'humect',
      this.getChartSeries('Hum', this.humiditySensor),
      this.getRanges('4_humidity'),
      this.getLimits('4_humidity')
    );
    this.temperatureChart = this.getConfigChar(
      'humTemp',
      this.getChartSeries('Temp', this.temperatureSensor),
      this.getRanges('4_temperature'),
      this.getLimits('4_temperature')
    );
  }

  public static getVariables(): any[] {
    return [
      { title: 'Temperatura', value: '4_temperature' },
      { title: 'Humedad relativa', value: '4_humidity' },
    ];
  }
}